<template>
  <b-input
    v-model="form.name"
    :error-messages="getErrorMessages(v$.name)"
    label="Назва"
    placeholder="Введіть назву"
    @blur="v$.name.$touch()" />
  <b-input v-model="form.description" label="Опис" placeholder="Введіть опис" />
  <b-select
    v-model="form.flowType"
    :items="flowTypes"
    :loading="flowTypesLoading"
    clearable
    item-title="name"
    item-value="id"
    label="Стратегія флоу" />
</template>
<script lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import {
  docTypeClassCreate,
  docTypeClassFlowTypes,
  docTypeClassUpdate,
} from '@/requests/documentType'
import { DocumentClassTypeCredentials } from '@/utils/types/documentClassType'
import { pushDirectoryItem, updateDirectoryItem } from '@/directory'
import { pick } from 'lodash'

export default {
  name: 'DocTypeClass',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  setup(props) {
    const isUpdate = props.dialog.action === 'update'
    const itemData = props.dialog.dialogData?.itemData

    const form = reactive<DocumentClassTypeCredentials>({
      name: itemData?.name,
      description: itemData?.description ?? null,
      flowType: itemData?.flowType ?? null,
    })

    const flowTypes = ref<any[]>([])
    const flowTypesLoading = ref(false)

    const v$ = useVuelidate({ name: { required } }, form)

    const submit = async () => {
      if (isUpdate) {
        const res = await docTypeClassUpdate(itemData.id, form)

        updateDirectoryItem('docTypeClasses', pick(res, ['id', 'name']))

        return res
      } else {
        const res = await docTypeClassCreate(form)
        pushDirectoryItem('docTypeClasses', pick(res, ['id', 'name']))
        return res
      }
    }

    onMounted(() => {
      flowTypesLoading.value = true
      docTypeClassFlowTypes()
        .then(res => {
          flowTypes.value = res
        })
        .finally(() => {
          flowTypesLoading.value = false
        })
    })

    return {
      form,
      v$,
      submit,
      validationScope: 'docTypeClass',
      flowTypes,
      flowTypesLoading,
    }
  },
}
</script>
